import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';

@Component({
    selector: 'subnav-module',
    template: `
    <div class="subnav-module-wrapper">
        <main-title *ngIf="mainTitleData" [data]="mainTitleData" [moduleId]="module.id" [uniqueId]="module.unique_id"></main-title>
        <eva-subnav
            *ngIf="subnav"
            [viewType]="viewType"
            [sticky]="sticky"
            [subnav]="subnav"
            [product]="'nymeria-gui'"
            [flow]="flow"
            class="eva-subnav-module"
            (onClickSubnavItem)="handleClickSubnavItem($event)"
        >
        </eva-subnav>
    </div>
    `,
    styleUrls: ['./eva-subnav.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SubnavModuleComponent {
    @Input() module: any;
    @Input() flow: string;
    // TODO: si una row no se dibuja, no debe mostrar el pills correspondiente
    constructor(private upaService: UpaService) {}

    handleClickSubnavItem(event: {type: string, value: string}): void {
        const { value, type } = event;
        const index = this.module.position;
        this.trackSelection(value, index, UpaTarget.SUBNAV);
    }


    private trackSelection(label: string, index: number, target: UpaTarget): void {
        this.upaService.trackClickTopic({
        label,
        positionIndex: index,
        moduleId: this.module.id,
        moduleIndex: this.module.position,
        target,
        uniqueId: this.module.unique_id
        });
    }


    get subnav() {
        return this.module?.data;
    }

    get viewType(): 'DEFAULT' | 'PILLS' {
        return this.subnav?.options?.view_type || 'DEFAULT';
    }

    get sticky(): boolean {
        return !!this.subnav?.options?.sticky;
    }

    get mainTitleData() {
        const { title, pretitle, subtitle } = this.module || {};

        if (!title && !pretitle && !subtitle) return null;

        return {title, pre_title: pretitle, sub_title: subtitle};
    }
}
